import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService, } from 'src/app/xena-api/controllers/base';
import { IXenaAppPlugin } from 'src/app/xena-api/dtos';
import { IListOptionsFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class XenaAppPluginService extends BaseService<IXenaAppPlugin, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'XenaAppPlugin');
  }

  listByApp(appId: number, filter: IListOptionsFilter = defaultListOptionsFilter): Observable<Page<IXenaAppPlugin>> {
    const path = `/Fiscal/${this.context.fiscalId}/XenaApp/${appId}/Plugin`;
    return this.xenaClient.list(path, filter);
  }
}

